import { isAuthenticated } from '../utils/authHelper';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogActions } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import Header from './Header';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import { browserHistory } from 'react-router'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { viewLinkInNewWindow, viewFile } from './viewFileUtilFunction';
import { createBulkPaymentRequests } from '../utils/PaymentRequestApiUtils';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
const constants = require('../config/constants');


const tdStyle = {
  padding: '10px',
  alignItems: 'center',
  border: '1px solid black',
  position: 'relative',
}

const tdTagStyle = {
  width: '200px',
  padding: '10px',
  alignItems: 'center',
  border: '1px solid black',
  position: 'relative',
  textAlign: 'center',
  borderRadius: '5px',
}

const tdTagBgColor = {
  'Success': '#4CAF50',
  'Error': '#f44336',
  'Pending': '#FFEB3B',
}


const theme = createMuiTheme({
  overrides: {
    MuiListItemText: {
      root: {
        padding: '0px'
      }
    }
  }
});

class BulkPreview extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      prs: [],
      checkBox: [],
      disabledCheckBox: [],
      faultyPRs: [],
      dialogBox: false,
      dialogBoxText: '',
      disable: true,
      prSelected: [],
      payload: [],
      prLogs: {},
      sendForApprovalDialog: false,
      inProgress: false,
    }
  }
  componentDidMount(props) {
    //delete this.props.location.state.faultyPRs.undefined;
    if (this.props.location.state && this.props.location.state.prObject) {
      let checkBox = [];
      let disabledCheckBox = [];
      for (let i = 0; i <= Object.values(this.props.location.state.prObject).length; i++) {
        checkBox[i] = false;
        disabledCheckBox[i] = false;
      }
      this.setState({ prs: Object.values(this.props.location.state.prObject), checkBox: checkBox, disabledCheckBox: disabledCheckBox });
      window.history.replaceState(null, null);
    } else {
      window.history.replaceState(null, null, "/");
      browserHistory.push('/initializePR');
      this.setState({ disable: true });
    }
  }

  //Verify validity of the invoice url (soft copy link)
  validURL(str) {
    var pattern = constants.urlRegxp;
    return !!pattern.test(str);
  }

  handleBack() {
    browserHistory.push('/initializePR');
  }

  handleApproval() {
    let disable = true;
    let payload = [];
    for (let i = 0; i < this.state.prs.length; i++) {
      if (this.state.checkBox[i]) {
        disable = false;
      }
    }
    if (!disable) {
      for (let i = 0; i < this.state.prSelected.length; i++) {
        if (this.state.prSelected[i] !== this.state.prs.length.toString() && this.state.checkBox[this.state.prSelected[i]]) {
          payload.push(this.state.prs[this.state.prSelected[i]]);
        }
      }
      this.setState({ sendForApprovalDialog: true, payload: payload });
    }
    else {
      this.setState({ disable: true });
    }
  }

  updatePrLogs = (data, apiLoading, apiStatus) => {
    const prLogsTemp = { ...this.state.prLogs };
    const checkBoxArr = [...this.state.checkBox];
    const disabledCheckBoxArr = [...this.state.disabledCheckBox];

    if (Array.isArray(data)) {
      for (let item of data) {
        const findIndex = this.state.prs.findIndex(pr => {
          if (pr.type_of_payment === 'Final Settlement') {
            return pr.unique_id === item.unique_id && pr.vendor_code === item.vendor_code;
          } else if (pr.type_of_payment === 'Advance Against PO') {
            return pr.po_number === item.unique_id && pr.vendor_code === item.vendor_code;
          }
          return false; // Explicitly return false if none of the conditions match
        });

        if (findIndex !== -1) {
          prLogsTemp[findIndex] = {
            status: item.message,
            apiLoading,
            apiStatus
          };

          // Disable checkbox for the processed PR
          disabledCheckBoxArr[findIndex] = true;
          checkBoxArr[findIndex] = false;
        }
      }
    } else {
      this.state.prSelected.forEach(pr => {
        if (prLogsTemp[pr]) {
          prLogsTemp[pr] = {
            status: data,
            apiLoading,
            apiStatus
          };

          // Disable checkbox for the processed PR
          disabledCheckBoxArr[pr] = true;
          checkBoxArr[pr] = false;
        }
      });
    }

    const updatedState = {
      prLogs: prLogsTemp,
      inProgress: false,
      prSelected: [],
      disabledCheckBox: disabledCheckBoxArr,
      checkBox: checkBoxArr,
    }

    const allTrueWithoutLast = disabledCheckBoxArr.slice(0, -1).every(value => value === true);
    if (allTrueWithoutLast) {
      updatedState.disabledCheckBox[this.state.prs.length] = true;
      updatedState.disable = true;
      updatedState.checkBox[this.state.prs.length] = false;
    }

    if (apiStatus === 'Error') {
      updatedState.dialogBox = true;
      updatedState.dialogBoxText = 'An error occurred while processing the payment requests. Please reupload and try again.';
    }

    // Update state once with the final prLogsTemp
    this.setState(updatedState);
  }

  async sendForApproval() {
    // Prepare prLogsTemp with initial updates
    const prLogsTemp = { ...this.state.prLogs };
    this.state.prSelected.forEach(pr => {
      if (!prLogsTemp[pr]) {
        prLogsTemp[pr] = {
          status: 'In Progress',
          apiLoading: true,
          apiStatus: 'Pending'
        };
      }
    });

    // Update state once before API call
    this.setState({
      sendForApprovalDialog: false,
      inProgress: true,
      prLogs: prLogsTemp
    });

    try {
      const response = await createBulkPaymentRequests(JSON.stringify({ ...this.state.payload }));
      if (response.status !== 'false') {
        // Update prLogs based on response
        this.updatePrLogs(response.data, false, 'Success');
      } else {
        // Handle error case
        this.updatePrLogs(response.data, false, 'Error');
      }
    } catch (error) {
      // Handle error case
      this.updatePrLogs(error.message, false, 'Error');
    } finally {
      this.setState({
        inProgress: false,
        disable: true
      })
    }
  }

  handleClose() {
    browserHistory.push('/');
  }

  handleCloseDialogBox() {
    this.setState({ dialogBox: false, dialogBoxText: '' });
  }

  handleApprovalClose() {
    this.setState({ sendForApprovalDialog: false });
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Header />
        <div style={{ padding: '1rem' }}>
          <h2 style={{ textAlign: 'left' }}>Valid Payment Requests: </h2>
          <p style={{ textAlign: 'left', color: 'red' }}>
            Please note: <span style={{ fontStyle: 'italic', fontWeight: 500 }}>If any single payment request creation fails, the entire batch of selected payments will not be processed.</span>
          </p>
          <table style={{ width: '100%' }}>
            <tr>
              <th style={tdStyle}>
                <Checkbox
                  id='All'
                  checked={this.state.checkBox[this.state.prs.length] ? true : false}
                  disabled={this.state.disabledCheckBox[this.state.prs.length] ? true : false}
                  onChange={(event) => {
                    if (event.target.checked) {
                      let pr = [];
                      let checkBox = [...this.state.checkBox];
                      for (let i = 0; i < this.state.prs.length; i++) {
                        if (this.state.disabledCheckBox[i] === false) {
                          checkBox[i] = true;
                          pr.push(i.toString());
                        }
                      }
                      checkBox[this.state.prs.length] = true;
                      pr.push(this.state.prs.length.toString());
                      this.setState({ prSelected: pr, checkBox: checkBox, disable: false })
                    }
                    else {
                      let pr = [...this.state.prSelected];
                      let checkBox = [...this.state.checkBox];
                      for (let i = 0; i <= this.state.prs.length; i++) {
                        checkBox[i] = false;
                        pr = [];
                      }
                      this.setState({ prSelected: pr, checkBox: checkBox, disable: true })
                    }

                  }}
                  value="checkedB"
                  color="primary"
                />
              </th>
              <th style={tdStyle}>Payment Request</th>
              <th style={tdStyle}>Status</th>
            </tr>
            {this.state.prs && this.state.prs.map((pr, index) => {
              return (
                <tr>
                  <td style={tdStyle} align="center">
                    <Checkbox
                      id={index.toString()}
                      checked={this.state.checkBox[index] ? true : false}
                      disabled={this.state.disabledCheckBox[index] ? true : false}
                      onChange={(event) => {
                        if (event.target.checked) {
                          let pr = [...this.state.prSelected];
                          let checkBox = [...this.state.checkBox];
                          checkBox[index] = true;
                          pr.push(index.toString());
                          this.setState({ prSelected: pr, checkBox: checkBox, disable: false });
                        }
                        else {
                          let pr = [...this.state.prSelected];
                          let checkBox = [...this.state.checkBox];
                          checkBox[index] = false;
                          checkBox[this.state.prs.length] = false;
                          for (let i = 0; i < pr.length; i++) {
                            if (pr[i] === index.toString()) {
                              pr.splice(i, 1);
                            }
                          }
                          let disable = true;
                          for (let i = 0; i < this.state.prs.length; i++) {
                            if (checkBox[i]) {
                              disable = false;
                            }
                          }
                          this.setState({ prSelected: pr, checkBox: checkBox, disable: disable })//, ()=>console.log(this.state.checkBox) )
                        }
                      }}
                      value="checkedB"
                      color="primary"
                    />
                  </td>
                  <td style={tdStyle} align="center">
                    <ExpansionPanel style={{ overflow: 'auto', maxWidth: 'calc(100vw - 420px)' }}>
                      <ExpansionPanelSummary style={{ backgroundColor: 'lightgray' }} expandIcon={<ExpandMoreIcon />}>
                        <Typography ><b>{index + 1}: {pr.type_of_payment === "Final Settlement" ? `Invoice Number: ${pr.unique_id} ` : `PO Number: ${pr.po_number}`} ,  Vendor Name: {pr.vendor_name} ({pr.vendor_code})</b></Typography>
                      </ExpansionPanelSummary>
                      <Grid container spacing={3}>
                        <List style={{ width: '98%', padding: '10px' }}>
                          <div style={{ display: 'flex' }}>
                            <div style={{ width: '33%' }}>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Vendor name" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.vendor_name} />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Type of Payment" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.type_of_payment}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Invoice Number " />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.type_of_payment === 'Final Settlement' ? pr.unique_id : ''} />
                              </ListItem>
                              {pr.type_of_payment === 'Final Settlement' && pr.invoice_soft_copy_link !== '' && pr.invoice_soft_copy_link !== null &&
                                this.validURL(pr.invoice_soft_copy_link) &&
                                pr.unique_id !== '' &&
                                <ListItem>
                                  <button style={{ marginLeft: '135px' }} onClick={() => viewLinkInNewWindow(pr.invoice_soft_copy_link)}>
                                    View Invoice
                                  </button>
                                </ListItem>
                              }
                              {pr.supporting_document_link !== '' && pr.supporting_document_link !== null &&
                                this.validURL(pr.supporting_document_link) &&
                                <ListItem>
                                  <button style={{ marginLeft: '135px' }} onClick={() => viewLinkInNewWindow(pr.supporting_document_link)}>
                                    View Supporting Document
                                  </button>
                                </ListItem>
                              }
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Expenditure of month" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.expenditure_month}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="PO Number" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.po_number}
                                />
                              </ListItem>
                              {pr.type_of_payment === 'Advance Against PO' && pr.invoice_soft_copy_link !== '' && pr.invoice_soft_copy_link !== null &&
                                this.validURL(pr.invoice_soft_copy_link) &&
                                <ListItem>
                                  <button style={{ marginLeft: '180px' }} onClick={() => viewLinkInNewWindow(pr.invoice_soft_copy_link)}>
                                    View Purshase Order
                                  </button>
                                </ListItem>
                              }
                            </div>
                            <div style={{ width: '33%' }}>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Date of Invoice" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.date ? moment(pr.date, 'DD-MM-YYYY').format('MMMM Do YYYY') : pr.date}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Expenditure Start Date" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.expenditure_start_date ? moment(pr.expenditure_start_date, 'DD-MM-YYYY').format('MMMM Do YYYY') : pr.expenditure_start_date}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Expenditure End Date" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.expenditure_end_date ? moment(pr.expenditure_end_date, 'DD-MM-YYYY').format('MMMM Do YYYY') : pr.expenditure_end_date}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Mode of Payment" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.mode_of_payment}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Business unit" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.business_unit}
                                />
                              </ListItem>

                            </div>
                            <div style={{ width: '33%' }}>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Bill Type" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.bill_type}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary="Narration" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.narration}
                                />
                              </ListItem>
                              <ListItem >
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" TDS Liability" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.tds_liability} />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" IT Section Applicable" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.it_section_applicable} />
                              </ListItem>
                              {pr.type_of_payment === 'Final Settlement' &&
                                <ListItem>
                                  <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Bill Availability" />
                                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                  <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.bill_availability} />
                                </ListItem>}
                            </div>
                          </div>
                        </List>
                      </Grid>
                      <div style={{ width: '98%', padding: '10px' }}>
                        {pr.ccae.map((data, index) => {
                          return (<ExpansionPanel>
                            <ExpansionPanelSummary style={{ backgroundColor: 'lightgray' }} expandIcon={<ExpandMoreIcon />}>
                              <Typography >Cost Center Details {index + 1}</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                              <div style={{ marginLeft: '68px' }}>
                                <TextField
                                  label='Entity'
                                  value={data.zolo_center_name}
                                  margin='normal'
                                  style={{ width: '520px' }}
                                />
                                {data.gam.map((gst_data, gst_index) => {
                                  return <div style={{ display: 'grid', gridTemplateColumns: '90%' }}>
                                    <div style={{ overflow: 'scroll', whiteSpace: 'nowrap' }}>
                                      <TextField
                                        label={`Amount ${gst_index + 1}`}
                                        value={gst_data.split_amount}
                                        margin='normal'
                                        style={{ width: '150px' }}
                                      />
                                      <TextField
                                        label='GST Slab'
                                        value={gst_data.gst_slab}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label='TDS Slab'
                                        value={gst_data.tds_slab}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label="Deductions"
                                        value={gst_data.split_other_deduction}
                                        style={{ width: '150px', marginLeft: '15px' }}
                                        margin='normal'

                                      />
                                      <TextField
                                        label="Discount"
                                        value={gst_data.split_discount}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label="Ledger Name"
                                        value={gst_data.ledger_name}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label="Quantity"
                                        value={gst_data.quantity}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label="Rate"
                                        value={gst_data.rate}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label="Item Name"
                                        value={gst_data.item_name}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label="Desc"
                                        value={gst_data.item_description}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                      <TextField
                                        label="Currency"
                                        value={gst_data.currency === undefined ? "INR" : gst_data.currency}
                                        margin='normal'
                                        style={{ width: '150px', marginLeft: '15px' }}
                                      />
                                    </div>
                                  </div>
                                })}
                              </div>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                          )
                        })}
                      </div>
                      <Grid container spacing={3}>
                        <List style={{ width: '98%', padding: '10px' }}>
                          <div style={{ display: 'flex', width: '100%' }}>
                            <div style={{ width: '100%' }}>
                              <ListItem >
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Amount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_amount} />
                              </ListItem>
                              <ListItem >
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" GST Type" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.gst_type} />
                              </ListItem>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" CSGT amount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_cgst_amount.toFixed(2)} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" SGST amount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_sgst_amount.toFixed(2)} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" IGST amount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_igst_amount.toFixed(2)} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" UGST amount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_ugst_amount.toFixed(2)} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Total GST amount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_gst_amount.toFixed(2)} />
                              </ListItem>

                            </div>
                            <div style={{ width: '30%' }}>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" TDS Deduction" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_tds_deduction.toFixed(2)} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Other Deduction" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_other_deduction} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Discount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_discount} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Advance" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.advance} />
                              </ListItem>

                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Total Payable Amount" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.pr_payable_amount.toFixed(2)} />
                              </ListItem>

                            </div>
                            <div style={{ width: '30%' }}>
                              <ListItem>
                                <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Is Recoverable" />
                                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.is_recoverable} />
                              </ListItem>

                              {(pr.is_recoverable === 'true') &&
                                <div>
                                  <ListItem>
                                    <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Amount Recoverable" />
                                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                    <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.amount_recoverable} />
                                  </ListItem>

                                  <ListItem>
                                    <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" As Per Agreement" />
                                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                    <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.as_per_agreement} />
                                  </ListItem>

                                  <ListItem>
                                    <ListItemText style={{ minWidth: '125px', maxWidth: '125px' }} primary=" Any proof" />
                                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                                    <ListItemText style={{ minWidth: '185px', wordWrap: 'break-word' }} primary={pr.amt_recoverable_proof_file_name} />
                                  </ListItem>
                                </div>
                              }
                            </div>
                          </div>
                        </List>
                      </Grid>
                    </ExpansionPanel>
                  </td>
                  <td style={tdStyle} align="center" >
                    {this.state.prLogs[index] ? (
                      <div
                        style={{
                          ...tdTagStyle,
                          backgroundColor: tdTagBgColor[this.state.prLogs[index].apiStatus],
                          color: this.state.prLogs[index].apiStatus === 'Pending' ? '#111' : '#fff',
                        }}
                      >
                        {this.state.prLogs[index].status}
                      </div>
                    ) : (
                      <div
                        style={{
                          ...tdTagStyle,
                          backgroundColor: '#f0f0f0',
                          color: '#111',
                        }}
                      >
                        Awaiting Submission
                      </div>
                    )}
                  </td>
                </tr>
              )
            })}
          </table>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" size="large" disabled={this.state.inProgress} style={{ marginTop: '30px', marginLeft: '12px', backgroundColor: 'rgb(220,20,60)', color: 'white' }} onClick={this.handleBack.bind(this)}>
              Go Back and Upload Again
            </Button>
            <Button variant="contained" size="large" style={{ marginTop: '30px', marginLeft: '12px', backgroundColor: (this.state.disable || this.state.inProgress) ? 'gray' : 'rgb(121,183,79)', color: 'white' }} disabled={this.state.disable || this.state.inProgress} onClick={this.handleApproval.bind(this)}>
              Send only Selected Requests For Approval
            </Button>
            {this.state.disabledCheckBox.every((item) => item == true) ? (
              <Button variant="contained" size="large" style={{ marginTop: '30px', marginLeft: '12px', backgroundColor: '#00AEFF', color: 'white' }} disabled={!this.state.disabledCheckBox.every((item) => item == true)} onClick={this.handleClose.bind(this)}>
                Go back to Dashboard
              </Button>
            ) : null}
          </div>
        </div>
        <Dialog
          open={this.state.dialogBox}
          onClose={this.handleCloseDialogBox.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h4 style={{ textAlign: 'center' }}>{this.state.dialogBoxText}</h4>
            </DialogContentText>
          </DialogContent>
          <Button style={{ backgroundColor: 'rgb(135, 206, 235)', color: 'white' }} primary={true} onClick={this.handleCloseDialogBox.bind(this)}>OK</Button>
        </Dialog>
        <Dialog
          modal={false}
          open={this.state.sendForApprovalDialog}
          onClose={this.handleApprovalClose.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h4 style={{ textAlign: 'center' }}>You have selected {this.state.payload.length}/{this.state.prs.length} Payment Requests for approval.</h4>
              <h5 style={{ textAlign: 'center' }}>Are you sure you want to continue ? </h5>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center', gap: '1rem' }}>
            <Button size="large" onClick={this.handleApprovalClose.bind(this)} color="secondary" variant="contained">
              NO
            </Button>
            <Button size="large" onClick={this.sendForApproval.bind(this)} color="primary" autoFocus variant="contained">
              YES
            </Button>
          </DialogActions>
          {/* <span>
          <Button style={{ backgroundColor:'rgb(135, 206, 235)',color:'green' }} primary={"true"} onClick={}>Yes</Button>
          
          <Button style={{ backgroundColor:'rgb(135, 206, 235)',color:'red' }} primary={"false"} onClick={}>No</Button>
          </span> */}
        </Dialog>
      </MuiThemeProvider>
    )
  }
}
export default BulkPreview



// WEBPACK FOOTER //
// ./src/components/BulkPreview.js